import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getApiUrl } from "../../services/api_service";
import {
    Box, Button, Checkbox, CircularProgress, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle,
    Divider, FormControlLabel, FormGroup, Grid, IconButton, LinearProgress, Radio, RadioGroup, Snackbar, TextField
} from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import { Alert, Typography } from "@mui/material";
import dayjs from "dayjs";
import CloseIcon from '@mui/icons-material/Close';
import { Redirect } from "react-router-dom";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { bodyBg, fullHeight, headerText, mainGrid, orangecolor, pcolor } from "../../style2";
import BackToTop from "../../components/shared/scrollTop";
import { DownloadFormButton } from "../../components/shared/downloadformbutton";


export default function ProcessForm(props) {
    const { orgCode, id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [form, setForm] = useState(null);
    const [referral, setReferral] = useState(null);
    const [patient, setPatient] = useState(null);
    const [sectionIndex, setSectionIndex] = useState(0);
    const [validateQuestion, setValidateQuestions] = useState(false);
    const [dummy, setDummy] = useState(Date.UTC());
    const [redirect, setRedirect] = useState('');
    const [showSubmitConfirmModal, setShowSubmitConfirmModal] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [readOnly, setReadOnly] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setLoggedIn(true);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/patientform/${id}`, { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForm(data.form);
                        setPatient(data.patient);
                        setReferral(data.referral);
                        setReadOnly(data.readOnly)
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [id]);

    const prepareAnswerList = () => {
        let answers = []
        form.sections.map(section => {
            section.questions.map(question => {
                if (question.answerType === 1 || question.answerType === 2 || question.answerType === 3) {
                    answers.push({ questionId: question.id, answer: question.answerText, selectedOptions: [] });
                } else if (question.answerType === 4 || question.answerType === 6 || question.answerType === 7) {
                    let selectedOptionIds = [];
                    question.options.filter(t => t.selected).map(item => { selectedOptionIds.push(item.id); });

                    answers.push({ questionId: question.id, answer: null, selectedOptions: selectedOptionIds });
                } else if (question.answerType === 5 && question.questions != null) {
                    question.questions.map(subQuestion => {
                        if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                            answers.push({ questionId: subQuestion.id, answer: subQuestion.answerText, selectedOptions: [] });
                        } else if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                            let selectedOptionIds = [];
                            subQuestion.options.filter(t => t.selected).map(item => { selectedOptionIds.push(item.id); });
                            answers.push({ questionId: subQuestion.id, answer: null, selectedOptions: selectedOptionIds });
                        }
                    })
                }
            })
        });
        return answers;
    }

    const saveAnswers = () => {
        if (form.status === 3 || form.status === 4) {
            setError("Submitted / Complete forms cannot be edited.");
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/patientform/setanswers/${id}`, {
            method: 'POST',
            body: JSON.stringify(prepareAnswerList()),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForm(data);
                        setSuccess('Answers saved in draft.');
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    const setSubmitted = () => {
        if (form.status === 3 || form.status === 4) {
            setError("Submitted / Complete forms cannot be submitted.");
            return;
        }
        setLoading(true);
        setShowSubmitConfirmModal(false);
        fetch(`${getApiUrl()}/patientform/setsubmitted/${id}`, {
            method: 'POST',
            body: JSON.stringify(prepareAnswerList()),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.status === 200) {

                    response.json().then(data => {
                        setForm(data);
                        setSuccess("Form is submitted, Please wait while we review the answers.");
                    })
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    const autoFillFunc = () => {
        if (referral === null)
            return;

        if (form.sections !== null) {
            form.sections.map((section, index) => {
                if (index !== sectionIndex)
                    return null;
                if (section.questions !== null) {
                    section.questions.map((question, qIndex) => {
                        let qt = question.questionText.toLowerCase();
                        //console.log(`QT: ${qt}, AnswerType: ${question.answerType}`);
                        if (question.answerType === 1 || question.answerType === 2 || question.answerType === 3) {
                            if ((question.answerText === null || question.answerText === "")) {

                                if (qt === "dob" || qt == "date of birth") {
                                    question.answerText = dayjs(referral.dob).format("YYYY-MM-DD");
                                } else if (qt === "forename" || qt === "firstname" || qt === "first name" || qt == "name of child") {
                                    question.answerText = referral.firstName;
                                }
                                else if (qt === "surname" || qt === "lastname" || qt === "last name") {
                                    question.answerText = referral.surName;
                                } else if (qt === "nhsnumber" || qt === "nhs number") {
                                    question.answerText = referral.nhsNumber;
                                }
                                else if (qt === "postcode" || qt === "post code") {
                                    question.answerText = referral.postCode;
                                }
                            }
                        } else if (question.answerType === 5) {
                            if (question.questions !== null) {

                                {
                                    question.questions.map((subQuestion) => {
                                        let sqt = subQuestion.questionText.toLowerCase();
                                        //console.log(`QT: ${sqt}, AnswerType: ${subQuestion.answerType}`);
                                        if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                                            if ((subQuestion.answerText === null || subQuestion.answerText === "")) {
                                                if (sqt == "dob" || sqt == "date of birth") {
                                                    subQuestion.answerText = dayjs(referral.dob).format("YYYY-MM-DD");
                                                } else if (sqt === "forename" || sqt === "firstname" || sqt === "first name"  || sqt == "name of child") {
                                                    subQuestion.answerText = referral.firstName;
                                                }
                                                else if (sqt === "surname" || sqt === "lastname" || sqt === "last name") {
                                                    subQuestion.answerText = referral.surName;
                                                } else if (sqt === "nhsnumber" || sqt === "nhs number") {
                                                    subQuestion.answerText = referral.nhsNumber;
                                                } else if (sqt === "postcode" || sqt === "post code") {
                                                    subQuestion.answerText = referral.postCode;
                                                }
                                            }
                                        }
                                    })
                                }

                            }
                        }
                    })
                }
            })
        }
        setForm(form);
        setDummy(new Date());
        
    }

    const sectionAnsweredComplete = () => {
        if (form != null && form.sections !== null) {
            let section = form.sections[sectionIndex];
            for (let k in section.questions) {
                let question = section.questions[k];
                if ((question.answerType === 1 || question.answerType === 2 || question.answerType === 3) && question.isRequired) {
                    if (question.answerText === null || question.answerText === "")
                        return false;
                }
                if ((question.answerType === 4 || question.answerType === 6 || question.answerType === 7) && question.isRequired) {
                    if (question.options.filter(t => t.selected).length === 0)
                        return false;
                } else if (question.answerType === 5 && question.isRequired) {
                    if (question.questions !== null) {
                        for (let l in question.questions) {
                            let subQuestion = question.questions[l];

                            if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                                if (subQuestion.answerText === null || subQuestion.answerText === "")
                                    return false;
                            }
                            if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                                if (subQuestion.options.filter(t => t.selected).length === 0)
                                    return false;
                            }
                        }

                    }
                }
            }
        }
        return true;
    }

    const isFormReadOnly = () => {
        return readOnly;
    }

    if (redirect !== "")
        return <Redirect to={redirect} />

    return <Box sx={{...bodyBg, ...fullHeight}}>
        <CssBaseline />
        <MetaDecorator title={"EnrichMyCare - Answer Form"} description={"Answer Form"} />
        <NDReferralHeader date={Date.UTC()} orgCode={orgCode} isLoggedIn={isLoggedIn} logo="../../../Logo_Option_1.svg" />
        {form !== null ? <>
            <Snackbar open={error !== ""} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={60000}
                onClose={() => { setError('') }} message={error}
                action={<>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={() => { setError('') }}> <CloseIcon fontSize="small" /> </IconButton>
                </>}
            />
            <Snackbar open={success !== ""} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={60000} onClose={() => { setSuccess('') }}
                message={success} action={<> <IconButton size="small" aria-label="close" color="inherit" onClick={() => { setSuccess('') }}> <CloseIcon fontSize="small" /> </IconButton> </>}
            />
            <Box pt={1} sx={{...bodyBg, marginTop: "5px"}} p={5}>
                {referral !== null ? <Box pt={1} pb={1}>
                    <Button sx={{ marginRight: "30px", background: pcolor, borderRadius: "20px", height: "40px", color: "#fff", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                        setRedirect(`/referral/details/${orgCode}/${referral.id}`);
                    }}>Back to Forms</Button>
                </Box> : null}

                <Typography variant="body1" mt={2} mb={3} style={{ fontSize: "1.2rem" }}>
                    {patient !== null ? `${patient.firstName} ${patient.surname}, ${dayjs(patient.dob).format('DD-MM-YYYY')}` : null}
                </Typography>

                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant="h5" sx={{...headerText, fontWeight: "bold"}} mb={2}>
                            {form.title} {isFormReadOnly() ? "(Read Only)" : null}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }}>
                        
                        {isFormReadOnly() ? <DownloadFormButton color="error" form={form} /> : <>
                        <span style={{ marginRight: "20px" }}><span style={{ color: "#e57373" }}>*</span> = Mandatory questions</span>
                        <Button type="button" variant="contained" disabled={loading} onClick={() => { autoFillFunc(); }}
                            style={{ background: orangecolor, borderRadius: 15, width: "150px", color: "#fff", textTransform: "capitalize", marginLeft: "15px", marginRight:"15px" }}>Auto Fill</Button></>}
                        {(form.status === 1 || form.status === 2) && !isFormReadOnly() ? <Button variant="contained" disabled={loading}
                            style={{ background: orangecolor, borderRadius: 15, width: "150px", color: "#fff", textTransform: "capitalize" }}
                            onClick={() => {
                                saveAnswers();
                            }}>{loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Save as Draft</Button> : null}
                            
                        

                    </Grid>
                </Grid>
                <Box pt={2} pb={2}>
                    <LinearProgress variant="determinate" sx={{ height: "15px", borderRadius: "20px" }} value={form.progressPercentage} />
                </Box>
                <Box pb={2} sx={{ marginBottom: "30px" }}>
                    {form.sections !== null && form.sections.map((section, index) => {
                        if (index !== sectionIndex)
                            return null;
                        return <Box sx={mainGrid} key={index} >
                            <Typography variant="h6" sx={{...headerText, fontWeight: "bold"}} mb={2}>{section.title}</Typography>

                            {section.questions !== null && section.questions.map((question, qIndex) => {
                                if (question.answerType === 1) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        <DateQuestionDisplay validate={validateQuestion} dummy={dummy} question={question} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);
                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 2) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        <TextQuestionDisplay validate={validateQuestion} dummy={dummy} question={question} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);

                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 3) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        <NumberQuestionDisplay validate={validateQuestion} question={question} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);
                                        }} />
                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 4 || question.answerType === 6 || question.answerType === 7) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        <MultipleChoiceQuestionDisplay validate={validateQuestion} question={question} onChange={(selectedIds) => {
                                            question.options.map(item => {
                                                if (selectedIds.filter(t => t === item.id).length === 0) {
                                                    item.selected = false;
                                                } else {
                                                    item.selected = true;
                                                }
                                            });
                                            setForm(form);

                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 5) {
                                    if (question.questions !== null) {
                                        return <Box pb={2} pt={2} style={{ marginBottom: "50px" }}>
                                            <Typography pb={1}>{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
                                            <Box pl={2} pr={2}>
                                                <Grid container>
                                                    {question.questions.map((subQuestion) => {
                                                        subQuestion.isRequired = question.isRequired;
                                                        if (subQuestion.answerType === 1) {
                                                            return <Grid item xs={6} >
                                                                <Box pl={1}>
                                                                    <DateQuestionDisplay dummy={dummy} sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);

                                                                    }} />

                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 2) {
                                                            return <Grid item xs={6} >
                                                                <Box pl={1}>
                                                                    <TextQuestionDisplay dummy={dummy} sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);

                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 3) {
                                                            return <Grid item xs={6} >
                                                                <Box pl={1}>
                                                                    <NumberQuestionDisplay sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);

                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                                                            return <Grid item xs={6} >
                                                                <Box pl={1}>
                                                                    <MultipleChoiceQuestionDisplay sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} onChange={(selectedIds) => {
                                                                        subQuestion.options.map(item => {
                                                                            if (selectedIds.filter(t => t === item.id).length === 0) {
                                                                                item.selected = false;
                                                                            } else {
                                                                                item.selected = true;
                                                                            }
                                                                        });
                                                                        setForm(form);
                                                                        setValidateQuestions(false);
                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else
                                                            return null;
                                                    })}
                                                </Grid>
                                            </Box>
                                        </Box>;
                                    } else
                                        return null;
                                } else
                                    return null;
                            })}
                        </Box>;
                    })}
                </Box>
            </Box>
            <Box style={{ width: "100%", background: "#F1EFDF", position: "fixed", bottom: 0, textAlign: "center" }}>
                <Box mt={2} mb={2}>
                    <Grid container >
                        <Grid item xs={6}  >
                            <Box pr={1} style={{ textAlign: "right" }}>
                                {sectionIndex > 0 ? <Button disabled={sectionIndex === 0 || loading} style={{ borderRadius: 15, background: "#fff", width: "100px", border: `2px solid ${orangecolor}`, textTransform: "capitalize" }} onClick={() => {
                                    if (sectionIndex > 0)
                                        setSectionIndex(sectionIndex - 1);
                                }}>Previous</Button> : null}
                            </Box>
                        </Grid>
                        <Grid item xs={6} pl={1}>
                            <Box pl={1} style={{ textAlign: "left" }}>
                                {sectionIndex + 1 < form.sections.length ? <Button disabled={loading} style={{ background: orangecolor, borderRadius: 15, width: "100px", color: "#fff", textTransform: "capitalize" }} onClick={() => {
                                    setValidateQuestions(true);
                                    setDummy(new Date());
                                    if (form.sections.length > sectionIndex + 1 && sectionAnsweredComplete()) {
                                        setSectionIndex(sectionIndex + 1);
                                        setValidateQuestions(false);
                                    }
                                }}>Next</Button> :
                                    (form.status === 1 || form.status === 2) && !isFormReadOnly() ? <>
                                        <Button disabled={loading} style={{ background: orangecolor, width: "100px", borderRadius: 15, color: "#fff", textTransform: "capitalize" }}
                                            onClick={() => {
                                                setValidateQuestions(true);
                                                setDummy(new Date());
                                                if (sectionAnsweredComplete()) {
                                                    setShowSubmitConfirmModal(true);
                                                }
                                            }}>
                                            {loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Submit
                                        </Button>
                                        <Dialog
                                            open={showSubmitConfirmModal}
                                            onClose={() => { setShowSubmitConfirmModal(false); }}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">
                                                <Typography style={{ fontSize: "1.3rem", fontWeight: "bold" }}>Please Confirm!</Typography>
                                            </DialogTitle>
                                            <DialogContent>
                                                <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                                                    You will not be able to edit the answer once the form is submitted.</Box>
                                                <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                                                    Are you sure you wish to submit?</Box>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button style={{ marginRight: "30px" }} onClick={() => { setShowSubmitConfirmModal(false); }}>Cancel</Button>
                                                <Button type="button" onClick={() => { setSubmitted(); }} style={{ background: orangecolor, width: "100px", borderRadius: 15, color: "#fff", textTransform: "capitalize" }}>Submit</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </> : null}
                                <BackToTop />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

        </> : <>
            {!loading ? <Alert severity="error">Unable to find requested form. If you need help please send email to contact@enrichmycare.com</Alert> : null}
        </>}


    </Box>;
}

export function DateQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        setAnswer(props.question.answerText !== null && props.question.answerText !== "" ? props.question.answerText : "");

        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    return <Box pb={2} pt={2}>
        <Typography pb={1}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            <TextField inputRef={inputRef} style={{ border: "1px solid #115C71", borderRadius: 5, width: "80%" }} inputProps={{ type: 'date' }} isRequired={props.question.isRequired} variant="outlined" value={answer} onChange={(event) => {
                setAnswer(event.target.value);
                props.onChange(event.target.value);
            }} />
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>
    </Box>;
}

function TextQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        setAnswer(props.question.answerText);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    return <Box pb={2} pt={2} >
        <Typography pb={1}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            <TextField inputRef={inputRef} maxLength={props.question.acceptMultiline ? 3000 : 300} multiline={props.question.acceptMultiline} style={{ border: "1px solid #115C71", borderRadius: 5, width: "80%" }} isRequired={props.question.isRequired} variant="outlined" value={answer} onChange={(event) => {
                setAnswer(event.target.value);
                props.onChange(event.target.value);
            }} />
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>

    </Box>
}

function NumberQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        setAnswer(props.question.answerText === null ? "" : props.question.answerText);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);
    return <Box pb={2} pt={2} >
        <Typography pb={1}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            <TextField inputRef={inputRef} variant="outlined" inputProps={{ maxLength: 12 }} style={{ border: "1px solid #115C71", borderRadius: 5, width: "80%" }} isRequired={props.question.isRequired} value={answer} onChange={(event) => {
                const regex = /^[0-9\b]+$/;
                if (event.target.value === "" || regex.test(event.target.value)) {
                    setAnswer(event.target.value);
                    props.onChange(event.target.value);
                }

            }} />
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>
    </Box>;
}

function MultipleChoiceQuestionDisplay(props) {
    const [question, setQuestion] = useState(props.question);
    const inputRef = useRef(null);
    useEffect(() => {
        setQuestion(props.question);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    const showValidateMessage = () => {
        if (props.validate && question.isRequired &&
            question.options.filter(t => t.selected).length === 0)
            return <Alert severity="error" style={{ background: "transparent" }}>Required</Alert>;
        else
            return null;
    }

    if (question.isMultipleChoice) {
        return <Box pb={2} pt={2} >
            <Typography pb={1}>{props.sequencePrefix}{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
            <Box pl={2} >
                <FormGroup >
                    {question.options !== null && question.options.map((option, oIndex) => {
                        return <FormControlLabel key={oIndex} control={<Checkbox inputRef={inputRef} value={option.id} defaultChecked={option.selected === true} onChange={(event) => {
                            question.options.map(item => {
                                if (item.id === event.target.value)
                                    item.selected = event.target.checked;
                            })
                            setQuestion(question);
                            let temp = [];
                            question.options.map(item => {
                                if (item.selected) {
                                    temp.push(item.id);
                                }
                            })
                            props.onChange(temp);
                        }} />} label={option.display} />;
                    })}
                </FormGroup>
                {showValidateMessage()}
            </Box>
        </Box>;
    } else {
        return <Box pb={2} pt={2}>
            <Typography pb={1}>{props.sequencePrefix}{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
            <Box pl={2}>
                <RadioGroup inputRef={inputRef}
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={question.options.filter(t => t.selected).length > 0 ? question.options.filter(t => t.selected)[0].id : ""}
                    name="radio-buttons-group"
                    row={question.answerType === 6 || question.answerType === 7}
                    isRequired={question.isRequired}
                >
                    {question.options !== null && question.options.map((option, oIndex) => {
                        return <FormControlLabel key={oIndex} value={option.id} control={<Radio value={option.id} onChange={(event) => {
                            let temp = [];
                            for (let k in question.options) {
                                if (question.options[k].id === option.id) {
                                    question.options[k].selected = true;
                                    temp.push(option.id);
                                } else {
                                    question.options[k].selected = false;
                                }
                            }
                            props.onChange(temp);
                        }} />} label={option.display} />;
                    })}
                </RadioGroup>
                {showValidateMessage()}
            </Box>
        </Box>;
    }
}